import { useRef } from 'react';

type SectionRefs<T extends string, E extends HTMLElement> = {
    [K in T as `${K}Ref`]: React.RefObject<E | null>;
};

export const useSectionRefs = <
    T extends string,
    E extends HTMLElement = HTMLDivElement
>(
    sectionNames: T[]
): SectionRefs<T, E> => {
    const refs = Object.fromEntries(
        // eslint-disable-next-line react-hooks/rules-of-hooks
        sectionNames.map(name => [`${name}Ref`, useRef<E | null>(null)])
    ) as SectionRefs<T, E>;

    return refs;
};
